import {
  REDEEMCODES_REQUEST, REDEEMCODES_SUCCESS, REDEEMCODES_FAILURE,
  REDEEMCODE_REQUEST, REDEEMCODE_SUCCESS, REDEEMCODE_FAILURE,
  REDEEMCODE_ADD_REQUEST, REDEEMCODE_ADD_SUCCESS, REDEEMCODE_ADD_FAILURE,
  REDEEMCODE_UPDATE_REQUEST, REDEEMCODE_UPDATE_SUCCESS, REDEEMCODE_UPDATE_FAILURE,
  REDEEMCODE_DELETE_REQUEST, REDEEMCODE_DELETE_SUCCESS, REDEEMCODE_DELETE_FAILURE,
  WRISTBAND_REDEEMCODES_REQUEST, WRISTBAND_REDEEMCODES_SUCCESS, WRISTBAND_REDEEMCODES_FAILURE,
  WRISTBAND_REDEEMCODE_ADD_REQUEST, WRISTBAND_REDEEMCODE_ADD_SUCCESS, WRISTBAND_REDEEMCODE_ADD_FAILURE
} from '../actions/redeemcodes'

const INITIAL_STATE = {
  redeemCodes: null, redeemCodesNeedRefresh: false, redeemCode: null, error: null,
  loading: false,
  wristbandRedeemCodes: null, wristbandRedeemCodesNeedRefresh: false, wristbandLoading: false, wristbandError: null
}

const redeemCodesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case REDEEMCODES_REQUEST:
      return {
        ...state,
        error: null, loading: true
      }
    case REDEEMCODES_SUCCESS:
      return {
        ...state,
        redeemCodes: action.response, redeemCodesNeedRefresh: false, error: null, loading: false
      }
    case REDEEMCODES_FAILURE:
      return {
        ...state,
        error: action.error, loading: false
      }
    case REDEEMCODE_REQUEST:
      return {
        ...state,
        error: null, loading: true
      }
    case REDEEMCODE_SUCCESS:
      return {
        ...state,
        redeemCode: action.response, error: null, loading: false
      }
    case REDEEMCODE_FAILURE:
      return {
        ...state,
        error: action.error, loading: false
      }
    case REDEEMCODE_ADD_REQUEST:
      return {
        ...state,
        error: null, loading: true
      }
    case REDEEMCODE_ADD_SUCCESS:
      return {
        ...state,
        redeemCodesNeedRefresh: true, error: null, loading: false
      }
    case REDEEMCODE_ADD_FAILURE:
      return {
        ...state,
        error: action.error, loading: false
      }
    case REDEEMCODE_UPDATE_REQUEST:
      return {
        ...state,
        error: null, loading: true
      }
    case REDEEMCODE_UPDATE_SUCCESS:
      return {
        ...state,
        redeemCodesNeedRefresh: true, error: null, loading: false
      }
    case REDEEMCODE_UPDATE_FAILURE:
      return {
        ...state,
        error: action.error, loading: false
      }
    case REDEEMCODE_DELETE_REQUEST:
      return {
        ...state,
        error: null, loading: true
      }
    case REDEEMCODE_DELETE_SUCCESS:
      return {
        ...state,
        redeemCodesNeedRefresh: true, error: null, loading: false
      }
    case REDEEMCODE_DELETE_FAILURE:
      return {
        ...state,
        error: action.error, loading: false
      }
    case WRISTBAND_REDEEMCODES_REQUEST:
      return { ...state, wristbandError: null, wristbandLoading: true }
    case WRISTBAND_REDEEMCODES_SUCCESS:
      return { ...state, wristbandRedeemCodes: action.response, wristbandRedeemCodesNeedRefresh: false, wristbandError: null, wristbandLoading: false }
    case WRISTBAND_REDEEMCODES_FAILURE:
      return { ...state, wristbandError: action.error, wristbandLoading: false }
    case WRISTBAND_REDEEMCODE_ADD_REQUEST:
      return { ...state, wristbandError: null, wristbandLoading: true }
    case WRISTBAND_REDEEMCODE_ADD_SUCCESS:
      return { ...state, wristbandRedeemCodesNeedRefresh: true, wristbandError: null, wristbandLoading: false }
    case WRISTBAND_REDEEMCODE_ADD_FAILURE:
      return { ...state, wristbandError: action.error, wristbandLoading: false }
    default:
      return state
  }
}

export default redeemCodesReducer